import guest from "@/middleware/guest";

export default [
    {
        path: "termos_home",
        name: "termos_home",
        meta: { middleware: [guest] },
        component: () => import("./TermosHome")
    }
];
